<template>
  <div class="search_bar_input--inner-button t-sm"
    v-tooltip.bottom="`Search by ${isEmpty(activeFields) ? 'specific fields' : activeFields.join(', ')}`"
  >
    <button
      class="btn btn-sm py-0 t-600"
      :class="!isEmpty(activeFields) ? 'btn-primary' : 'btn-outline-primary'"
      type="button"
      @click="fetchFields"
      v-html="`${isEmpty(activeFields) ?
        'Search by' :
        `Search by <span class='ml-1 semi-transparent'>${activeFields.length}</span>` }
      `"
    />
  </div>
</template>

<script>
import SearchService from '@/services/search'

export default {
  name: 'searchByFieldButton',
  props: {
    index: {
      type: String,
      required: true
    },
    activeFields: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      fieldsPerIndex: {} // Cache of searchable fields per index
    }
  },
  methods: {
    fetchFields () {
      // We already know which fields exist for this index, we need to check props to activate correct fields
      if (this.fieldsPerIndex[this.index]) {
        const fieldArray = this.fieldsPerIndex[this.index].map(field => {
          return {
            ...field,
            active: !!this.activeFields.find(f => f === field.name)
          }
        })

        this.$events.$emit('modal:search_by_fields', fieldArray, this.index)
        return
      }

      // Fetch fields info for index and activate correct fields based on props
      SearchService.getSearchableFields(this.index).then(fields => {
        const fieldArray = Object.entries(fields).map(([key, value]) => {
          return {
            name: key,
            active: !!this.activeFields.find(f => f === key),
            ...value
          }
        }).sort((a, b) => a.order - b.order)
        this.fieldsPerIndex[this.index] = fieldArray

        this.$events.$emit('modal:search_by_fields', fieldArray, this.index)
      })
    }
  }
}
</script>
